const init = () => {

    var $newsletter = $('.newsletter');
    if ($newsletter.length < 1) return;
    var $form = $newsletter.find('form');
    var $submit = $newsletter.find('button');
    var $success = $newsletter.find('.newsletter__success');
    var $field = $form.find('.InputParent input');
    var $feedback = $form.find('.newsletter__feedback');

    $submit.on('click', function(e) {
        $form.submit();
    });

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    $form.on('submit', function (e) {
        e.preventDefault();
        var $this = $(this);
        var isValid = validateEmail($field.val());
        if (isValid) {
            $submit.addClass('is-loading');
            grecaptcha.ready(function () {
                grecaptcha.execute(window.recaptchaKey, { action: 'submit' }).then(function (token) {
                    $.ajax({
                        method: 'POST',
                        url: $this.attr('data-action'),
                        data: $this.serialize() + "&recaptchaToken=" + token,
                        success: function (data) {
                            $newsletter.addClass('is-success');
                        },
                        error: function () {
                            $submit.removeClass('is-loading');
                        }
                    });
                });
            });
        } else {
            $feedback.text('Invalid email');
        }
    });

}

export default init;